module.exports = __webpack_public_path__ + "img/deonde-poweredby.78d60984.svg";